<template>
  <v-card
    elevation="2"
    rounded="0"
    class="subnav-header d-flex align-center px-4 py-1 text-default-content"
    color="default-panel"
    height="64"
  >
    <v-toolbar-title>{{ title }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <div class="subnav-header-filters d-flex align-center flex-wrap">
      <slot name="filters"></slot>
    </div>

    <div class="subnav-header-actions d-flex align-center">
      <slot name="actions"></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'BaseViewHeader',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
